// src/pages/CourseTime/styles/common.styles.js
import styled, { keyframes } from 'styled-components';

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Base layout
export const Layout = styled.div`
  position: absolute;
  top: 64px;
  display: flex;
  height: calc(100vh - 64px);
  width: 100%;
  overflow: hidden;
  background-color: #f9fafb;
  box-sizing: border-box;
    @media (max-width: 1024px) {
        margin-top: 60px;
    }
`;

// Main content
export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
  height: 100%;
  background-color: #fff;
  font-family: "Source Sans Pro", "Helvetica Neue";
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const Header = styled.header`
  //height: 64px;
  background: #fff;
  padding: 0 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  z-index: 5;
    @media (max-width: 768px) {
        height: auto;
    }
`;

export const Content = styled.main`
  flex: 1;
  padding: 0;
  background: #fff;
  overflow: auto;
  margin-top: 30px;
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 28px;
  font-weight: bold;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${({ themeColor }) => themeColor || '#32BAF1'};
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    background-color: #edf2f7;
  }
`;


export const MobileToggleButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: auto;
  font-size: 20px;
  color: #32BAF1;
    z-index: 10;
    @media (min-width: 1024px) {
        display: none;
    }
`;

export const SessionTitle = styled.div`
  font-size: 42px;
  font-weight: 600;
  color: ${({ themeColor }) => themeColor || '#EE6D29'};
  text-align: center;
  flex-grow: 1;
  margin: 0 16px;
    @media (max-width: 1024px) {
        font-size: 33px;
    }
    @media (max-width: 768px) {
        font-size: 25px;
    }
`;

export const ErrorMessage = styled.div`
  background-color: #fed7d7;
  color: #c53030;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 12px;
  border: 1px solid #feb2b2;
  animation: fadeIn 0.3s ease-in-out;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

// Loading states
export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f9fafb;
`;

export const ContentLoading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-family: "Source Sans Pro", "Helvetica Neue";
  min-height: 400px;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(66, 153, 225, 0.1);
  border-radius: 50%;
  border-top: 4px solid #32BAF1;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px;
`;

export const SpinnerSmall = styled.div`
  border: 3px solid rgba(66, 153, 225, 0.1);
  border-radius: 50%;
  border-top: 3px solid #32BAF1;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`;

export const NoContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #718096;
  font-size: 16px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`;

// Error Dialog Styles
const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ErrorDialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(4px);
  font-family: "Source Sans Pro", "Helvetica Neue";
`;

export const ErrorDialogContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: ${slideDown} 0.3s ease-out;
  overflow: hidden;
`;

export const ErrorDialogHeader = styled.div`
  background: #fed7d7;
  padding: 20px 24px;
  border-bottom: 1px solid #feb2b2;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ErrorDialogTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #c53030;
  display: flex;
  align-items: center;
  gap: 8px;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ErrorDialogCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #c53030;
  transition: all 0.2s ease;
  
  &:hover {
    background: #feb2b2;
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ErrorDialogContent = styled.div`
  padding: 24px;
`;

export const ErrorDialogMessage = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  line-height: 1.5;
  color: #2d3748;
`;

export const ErrorDialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const ErrorDialogButton = styled.button`
  background: #c53030;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #9b2c2c;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

